// The z-index ladder (WI 5799): page chrome < modal < popover < tooltip <
// confirm < toast. A component's own stacking stays in literal values below
// 100. theme.ts generates the --z-* properties from these values, and the
// PrimeVue config in main.ts takes the same numbers.

export const zIndex = {
  chrome: 100,
  modal: 900,
  popover: 1000,
  tooltip: 1100,
  confirm: 1200,
  toast: 1300,
} as const;
